<div  class="overlay" *ngIf="isLoading">
<div class="overlay-content">
  
  <p-progressSpinner ></p-progressSpinner>
</div>
</div>